import { render, staticRenderFns } from "./SoftwareLabels.vue?vue&type=template&id=07dece15&scoped=true&"
import script from "./SoftwareLabels.vue?vue&type=script&lang=js&"
export * from "./SoftwareLabels.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLabels.vue?vue&type=style&index=0&id=07dece15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dece15",
  null
  
)

export default component.exports